module.exports = __webpack_public_path__ + "img/1.35618a7a.jpg";